import http from 'plugins/axios';

function query(params = {}) {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/approval/enums' });
  },
  page(params) {
    return http.get({ url: `/ta/admin/tenant/vip/approval/page?${query(params)}` });
  },
  detail(id) {
    return http.get({ url: `/ta/admin/tenant/vip/approval/detail?id=${encodeURIComponent(id)}` });
  },
  review(data) {
    return http.post({ url: '/ta/admin/tenant/vip/approval/review', data });
  },
};
